import { Route } from '@angular/router';
import { AuthGuard } from './auth/guards/auth.guard';
import { ForgotPasswordStatusComponent } from './modules/auth/forgot-password-status/forgot-password-status.component';
import { ForgotPasswordComponent } from './modules/auth/forgot-password/forgot-password.component';
import { ProfileComponent } from './modules/auth/profile/profile.component';
import { ResendCodeComponent } from './modules/auth/resend-code/resend-code.component';
import { ResetPasswordStatusComponent } from './modules/auth/reset-password-status/reset-password-status.component';
import { ResetPasswordComponent } from './modules/auth/reset-password/reset-password.component';
import { AuthSignInComponent } from './modules/auth/sign-in/sign-in.component';
import { SignUpStatusComponent } from './modules/auth/sign-up-status/sign-up-status.component';
import { SignUpComponent } from './modules/auth/sign-up/sign-up.component';
import { BlogDetailsComponent } from './modules/landing/blog-details/blog-details.component';
import { BlogListComponent } from './modules/landing/blog/blog-list.component';
import { CorporateScreenComponent } from './modules/landing/corporate/corporate-screen.component';
import { FaqComponent } from './modules/landing/home/faq/faq.component';
import { LandingHomeComponent } from './modules/landing/home/home.component';
import { ProductsListComponent } from './modules/products/test-screen/products-list.component';
import { NewProductsComponent } from './modules/new-products/new-products.component';
import { NewDgpComponent } from './modules/new-dgp/new-dgp.component';
import { BusinessInfoComponent } from './modules/landing/corporate/business-info/business-info.component';
import { EligibleComponent } from './modules/landing/corporate/eligible/eligible.component';
import { StatusInfoComponent } from './modules/landing/corporate/status-info/status-info.component';
import { NonEligibleComponent } from './modules/landing/corporate/non-eligible/non-eligible.component';
import { ApplicationDashComponent } from './application/application-dash/application-dash.component';
import { ApplicationDraftComponent } from './application/application-draft/application-draft.component';
import { AboutUsComponent } from './modules/about-us/about-us.component';
import { AwardsAcheivementsComponent } from './modules/awards-acheivements/awards-acheivements.component';
import { MatchedProductsComponent } from './modules/landing/corporate/matched-products/matched-products.component';
import { environment } from 'environments/environment';
import { CgcNearestLocationComponent } from './modules/chatbot/cgc-nearest-location/cgc-nearest-location.component';
import { ApplicationPastComponent } from './application/application-past/application-past.component';
import { BusinessFormComponent } from './modules/chatbot/business-form/business-form.component';
import { ChatbotSurveyFormComponent } from './modules/chatbot/chatbot-survey-form/chatbot-survey-form.component';
import { CgcDevelopmentProgrammeComponent } from './modules/cgc-development-programme/cgc-development-programme.component';
import { InsuranceComponent } from './modules/insurance/insurance.component';
import { EsgComponent } from './modules/esg/esg.component';
import { MyKnpComponent } from './modules/my-knp/my-knp.component';
import { SmeComponent } from './modules/sme/sme.component';
import { CgcDevelopmentProgrammeFormComponent } from './modules/cgc-development-programme-form/cgc-development-programme-form.component';
import { ApplicationDocumentUploadComponent } from './modules/landing/corporate/application-document-upload/application-document-upload.component';
import { FiAgencyComponent } from './modules/fi-agency/fi-agency.component';
import { CampaignComponent } from './modules/campaign/campaign.component';
import { PartnershipsCampaignsComponent } from './modules/partnerships-campaigns/partnerships-campaigns.component';
import { DigitalGuaranteeComponent } from './modules/digital-guarantee/digital-guarantee.component';
import { MitiGrantsComponent } from './modules/miti-grants/miti-grants.component';
import { MitiDetailsComponent } from './modules/miti-details/miti-details.component';
import { FaqDetailsComponent } from './modules/landing/home/faq-details/faq-details.component';
import { LibertyLandingComponent } from './modules/liberty-landing/liberty-landing.component';
import { meta } from './shared/constant/meta';
import { ContactUsComponent } from './modules/landing/home/contact-us/contact-us.component';
import { FinancingCalculatorComponent } from './modules/financing-calculator/financing-calculator.component';
import { PartnershipComponent } from './modules/partnership/partnership.component';
import { DigitalServicesComponent } from './modules/digital-services/digital-services.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { ProfileSettingsComponent } from './modules/dashboard/modules/profile-settings/profile-settings.component';
import { ApplicationsComponent } from './modules/dashboard/modules/applications/applications.component';
import { InsurancePolicyStreetComponent } from './modules/insurance-policy-street/insurance-policy-street.component';
import { InsurancePolicyStreetSmeComponent } from './modules/insurance-policy-street-sme/insurance-policy-street-sme.component';
import { InsuranceSuccessComponent } from './shared/components/insurance-success/insurance-success.component';
// -- JC3 Components --
import { Jc3Component } from './modules/jc3/jc3.component';
import { RewardsComponent } from './modules/dashboard/modules/rewards/rewards.component';
import { Jc3FeedbackFormComponent } from './modules/dashboard/modules/jc3-feedback-form/jc3-feedback-form.component';
import { BukkuComponent } from './modules/digital-services/modules/bukku/bukku.component';
import { NotificationsComponent } from './modules/dashboard/modules/notifications/notifications.component';
import { ProjectInsuranceComponent } from './modules/project-insurance/project-insurance.component';
import { NotFoundComponent } from './modules/404/404.component';
import { UnderMaintenanceComponent } from './modules/under-maintenance/under-maintenance.component';
import { NewsDetailsComponent } from './modules/partnerships-campaigns/components/news-section/news-details/news-details.component';

export const appRoutes: Route[] = [
    // Redirect empty path to '/dashboards/project'
    // { path: '', pathMatch: 'full', redirectTo: '/dashboards/project' },

    // Redirect signed-in user to the '/dashboards/project'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    // {
    //     path: 'signed-in-redirect',
    //     pathMatch: 'full',
    //     redirectTo: 'dashboards/project',
    // },
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
    },
    {
        path: 'login',
        pathMatch: 'full',
        component: AuthSignInComponent,
        data: meta.LOGIN,
    },
    {
        path: 'resend-code',
        pathMatch: 'full',
        component: ResendCodeComponent,
    },
    {
        path: 'reset-password',
        pathMatch: 'full',
        component: ResetPasswordComponent,
    },
    {
        path: 'corporate',
        pathMatch: 'full',
        component: CorporateScreenComponent,
    },

    // Landing routes
    {
        path: 'home',
        component: LandingHomeComponent,
        data: meta.HOME,
    },
    {
        path: 'sign-up',
        component: SignUpComponent,
        data: meta.SIGN_UP,
    },
    {
        path: 'sign-up-status',
        component: SignUpStatusComponent,
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
    },
    {
        path: 'forgot-password-status',
        component: ForgotPasswordStatusComponent,
    },
    {
        path: 'reset-password-status',
        component: ResetPasswordStatusComponent,
    },
    {
        path: 'contact-us',
        component: ContactUsComponent,
        data: meta.CONTACT_US,
    },
    // {
    //     path: 'old-profile',
    //     canActivate: [AuthGuard],
    //     component: ProfileComponent,
    // },
    {
        path: 'faq',
        component: FaqComponent,
        data: meta.FAQ,
    },
    {
        path: 'faq/:category',
        component: FaqDetailsComponent,
    },
    ...(environment.dev
        ? [
              {
                  path: 'blogs/:id',
                  component: BlogDetailsComponent,
              },
          ]
        : []),
    ...(environment.dev
        ? [
              {
                  path: 'blogs',
                  component: BlogListComponent,
              },
          ]
        : []),
    // {
    //     path: 'blogs',
    //     pathMatch: 'full',
    //     component: BlogListComponent,
    // },
    // {
    //     path: 'products',
    //     pathMatch: 'full',
    //     component: ProductsListComponent,
    //     data: meta.PRODUCTS,
    // },
    {
        path: 'business-financing',
        pathMatch: 'full',
        component: NewProductsComponent,
        data: meta.PRODUCTS,
    },
    {
        path: 'business-info',
        pathMatch: 'full',
        component: BusinessInfoComponent,
    },
    {
        path: 'application-document-upload',
        pathMatch: 'full',
        component: ApplicationDocumentUploadComponent,
    },
    {
        path: 'matched-products',
        pathMatch: 'full',
        component: MatchedProductsComponent,
    },
    {
        path: 'check-eligibilty',
        pathMatch: 'full',
        component: EligibleComponent,
    },
    {
        path: 'non-eligible',
        pathMatch: 'full',
        component: NonEligibleComponent,
    },
    {
        path: 'status',
        pathMatch: 'full',
        component: StatusInfoComponent,
    },
    // {
    //     path: 'old-applications',
    //     component: ApplicationDashComponent,
    // },
    {
        path: 'applications',
        component: ApplicationsComponent,
    },
    // {
    //     path: 'past-applications',
    //     component: ApplicationPastComponent,
    // },
    {
        path: 'dashboard',
        canActivate: [AuthGuard],
        component: DashboardComponent,
    },
    {
        path: 'profile',
        canActivate: [AuthGuard],
        component: ProfileSettingsComponent,
    },
    {
        path: 'rewards',
        canActivate: [AuthGuard],
        component: RewardsComponent,
    },
    {
        path: 'notifications',
        canActivate: [AuthGuard],
        component: NotificationsComponent,
    },
    {
        path: 'feedback-form',
        canActivate: [AuthGuard],
        component: Jc3FeedbackFormComponent,
    },
    {
        path: 'draft',
        canActivate: [AuthGuard],
        component: ApplicationDraftComponent,
    },
    {
        path: 'about-us',
        component: AboutUsComponent,
        data: meta.ABOUT_US,
    },
    {
        path: 'awards-achievements',
        component: AwardsAcheivementsComponent,
        data: meta.AWARDS,
    },
    {
        path: 'cgc-nearest-location',
        component: CgcNearestLocationComponent,
    },
    {
        path: 'business-form',
        component: BusinessFormComponent,
    },
    {
        path: 'chatbot-survey-form',
        component: ChatbotSurveyFormComponent,
    },
    {
        path: 'cgc-developmental-programme',
        component: CgcDevelopmentProgrammeComponent,
        data: meta.CGC_DEVELOPMENT_PROGRAMME,
    },
    {
        path: 'cgc-developmental-programme/registration',
        component: CgcDevelopmentProgrammeFormComponent,
    },
    {
        path: 'digital-guarantee',
        component: NewDgpComponent,
        data: meta.DIGITAL_GUARANTEE,
    },
    {
        path: 'insurance',
        component: InsuranceComponent,
        data: meta.INSURANCE,
    },
    {
        path: 'insurance/liberty',
        component: LibertyLandingComponent,
        data: meta.INSURANCE_LIBERTY,
    },
    {
        path: 'insurance/liberty/projectinsurance',
        component: ProjectInsuranceComponent,
    },
    {
        path: 'insurance/success',
        component: InsuranceSuccessComponent,
    },
    {
        path: 'insurance/policy-street/employee-benefits',
        component: InsurancePolicyStreetComponent,
    },
    {
        path: 'insurance/policy-street/sme',
        component: InsurancePolicyStreetSmeComponent,
    },
    {
        path: 'digital-services',
        component: DigitalServicesComponent,
        data: meta.DIGITAL_SERVICES,
    },
    {
        path: 'digital-services/bukku',
        component: BukkuComponent,
    },
    // {
    //     path: 'esg',
    //     component: EsgComponent,
    //     data: meta.ESG,
    // },
    {
        path: 'myknp',
        component: MyKnpComponent,
        data: meta.MY_KNP,
    },
    {
        path: 'grants',
        component: MitiGrantsComponent,
        data: meta.GRANTS,
    },
    {
        path: 'financing-calculator',
        component: FinancingCalculatorComponent,
        data: meta.FINANCING_CALCULATOR,
    },
    {
        path: 'grants/:slug',
        component: MitiDetailsComponent,
    },
    {
        path: 'sme',
        component: SmeComponent,
        data: meta.SME,
    },
    // {
    //     path: 'campaign',
    //     component: CampaignComponent,
    // },
    {
        path: 'whats-new',
        component: PartnershipsCampaignsComponent,
        data: meta.PROMOTIONS,
    },
    {
        path: 'partnership',
        component: PartnershipComponent,
        data: meta.PARTNERS,
    },
    {
        path: 'campaign/:id/:slug',
        component: CampaignComponent,
    },
    {
        path: 'in-the-news/:id/:slug',
        component: NewsDetailsComponent,
    },
    {
        path: 'jc3-esg-jumpstart-for-smes',
        component: Jc3Component,
        data: meta.JC3,
    },
    { path: 'under-maintenance', component: UnderMaintenanceComponent },
    { path: '404', component: NotFoundComponent },
    { path: '**', component: NotFoundComponent },
];
